import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,message, Tree,Modal,Select, } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import {api_candidates_edit, api_candidates_add} from '../../api';

// const navigate = useNavigate();
  // navigate(-1)//适用于返回上级页面
  // navigate('/router');//也可直接加路径

// const { Header, Content, Footer, Sider } = Layout;
// const { TextArea } = Input;
// const { Option } = Select;
const screenHeight = document.body.clientHeight;

const App =(props)=>{
    const {showModal, closeModal, rowInfo, refreshlist} = props;
    console.log('1111111111111111candidateEdit111111111111111111111-', rowInfo)
    const [form] = Form.useForm();
    const [loading,setLoading] = useState(false);

    useEffect(() => {
      if(showModal){
        if(rowInfo.candidate_id == undefined){
          form.resetFields();
        } else {
          for (let key in rowInfo) {
            form.setFieldValue(key, rowInfo[key])
          }
        }
      }else{
        form.resetFields();
        setLoading(false);
      }
    }, [showModal]);

    const onFinish = async(value)=>{
      console.log(value);
      // if(!value.username){
      //   message.warn("请输入邮箱接口");
      //   return false;
      // }
      // setLoading(true);
      var fun = '';
      if(rowInfo.candidate_id){
        fun = api_candidates_edit;
        value.candidate_id = rowInfo.candidate_id;
      }else if(rowInfo.tenant_id && rowInfo.work_order_id){
        fun = api_candidates_add;
        value.tenant_id = rowInfo.tenant_id;
        value.work_order_id = rowInfo.work_order_id;
      }

      try {
        await fun(value).then((res) => {
          setLoading(false);
          console.log(fun+'-res-----------------', res);
          if (res.data.code == 9) {
            message.success("操作成功");
            closeModal();
            refreshlist();
          }else
            message.error(res.data.msg);
        });
        } catch (error) {
          message.error("异常"+error);
          setLoading(false);
          return false;
        }
  }

  return (
    <Modal 
        key="candinfo"
        title={(rowInfo.candidate_id?'编辑':'新增')+'候选人'}
        open={showModal}
        width={600}
        bodyStyle={{maxHeight:screenHeight*0.8,overflowY:"scroll"}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeModal}>
        取消
        </Button>,
        <Button type="primary" loading={loading} style={{ marginLeft:'20px',backgroundColor:"rgb(24,188,156)"}} onClick={()=>{form.submit()}}>
        确认
        </Button>] }
        onCancel={closeModal}>
          <Form form={form}
            className='loginForm reginfo'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            layout="horizontal"
            // onFinishFailed={this.onFinishFailed}
            autoComplete="off"
            labelAlign="left"
            labelCol={{span:5}}
            // style={{fontSize:12}}
            size="small"
            initialValues={{is_outlook_enabled:"0"}}
        >
            <Form.Item
                label="姓名"
                name="name"
                rules={[
                  {required: true, message: '请输入姓名',},
                ]}
            >
            <Input />
            </Form.Item>
            <Form.Item
                label="手机号"
                name="phone"
                rules={[
                  {required: true, message: '请输入手机号',},
                  {
                    pattern: /^1[3-9]\d{9}$/,
                    message: '请输入有效的手机号码',
                  },
                ]}
            >
            <Input />
            </Form.Item>
            <Form.Item
                label="邮箱"
                name="email"
                rules={[
                  {required: true, message: '请输入邮箱',},
                  {
                    type: 'email',
                    message: '请输入有效的邮箱地址',
                  },
                ]}
            >
            <Input />
            </Form.Item>

        </Form>
        </Modal>
  )
}
export default App
